/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {Account, AccountLink, GenericObject} from '@ion/core/src/types/entities';
import {createDeepEqualSelector} from './SelectorUtils';

export const selectGlobalGroup       = ({globalGroup: {globalGroup}}: any) => globalGroup;
export const selectAccountHierarchy  = ({globalGroup: {accountHierarchy}}: any) => accountHierarchy;
export const selectGlobalGroupId     = ({globalGroup: {globalGroupId}}): number => globalGroupId;
export const selectAncestorAccountId = ({globalGroup}) => globalGroup.ancestorAccountId;
export const selectAccountMap        = ({globalGroup: {accountMap}}): GenericObject => accountMap;
export const selectSolomonId         = ({globalGroup: {solomonId}}) => solomonId;
export const selectCurrentGroup      = ({globalGroup}) => globalGroup.currentAccount;
export const selectIsGGCInitialized  = ({globalGroup}) => globalGroup.isInitialized;
export const selectIsGGCLoading      = ({globalGroup}) => globalGroup.loading;

export const globalGroupSelector =
  createDeepEqualSelector([selectGlobalGroup], (globalGroup) => globalGroup);

export const ancestorAccountIdSelector = createSelector(
  selectAncestorAccountId,
  (ancestorAccountId) => ancestorAccountId
);

export const globalAccountMapSelector = createDeepEqualSelector(selectAccountMap,
  (accountMap: GenericObject): GenericObject => accountMap
);

export const globalGroupIdSelector = createDeepEqualSelector(selectGlobalGroupId,
  (accountId: number): number => accountId
);

export const globalGroupLoadingSelector = createSelector(selectIsGGCLoading,
  (loading: boolean): boolean => loading
);

export const globalGroupAccountHierarchySelector = createDeepEqualSelector(selectAccountHierarchy,
  (accountHierarchy: AccountLink[]): AccountLink[] => accountHierarchy
);

export const solomonIdSelector =
  createSelector(selectSolomonId, solomonId => solomonId);

export const globalCurrentGroupSelector = createDeepEqualSelector(selectCurrentGroup,
  (currentAccount: Account): Account => currentAccount
);

export const isGGCInitializedSelector = createSelector(selectIsGGCInitialized,
  (isInitialized: boolean): boolean => isInitialized
);
